export default {
    'ALTERAR_CLIENTE' (state, payload) {
        state.dados = payload;
    }
};
